import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/img/logo.png'; 
import './menu.scss';

const Menu = () => {
  const location = useLocation();
  const currentLocation = location.pathname;

  useEffect(() => {
    if (currentLocation === '/') {
      document.getElementById('root').style.backgroundColor="rgba(0, 0, 0, 0.90)";
      document.getElementById('footer-know').style.color="#fff";
      document.getElementById('footer-email').style.color="#fff";
      document.getElementById('footer-phone').style.color="#fff";
      document.getElementById('footer-ig').style.color="#fff";
      document.getElementById('footer-fb').style.color="#fff";
    } else {
      document.getElementById('root').style.backgroundColor="#fff";
      document.getElementById('footer-know').style.color="#000";
      document.getElementById('footer-email').style.color="#000";
      document.getElementById('footer-phone').style.color="#000";
      document.getElementById('footer-ig').style.color="#000";
      document.getElementById('footer-fb').style.color="#000";
    }
  }, [currentLocation]);

  return (
    <nav className="navbar navbar-expand-lg">
      <div className="container-fluid">
        <Link to='/' className="navbar-brand">
          <img 
            src={Logo} 
            alt='logo proyecto vertical'
            className='navbar-logo'  
          />
        </Link>
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarSupportedContent" 
          aria-controls="navbarSupportedContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div 
          className="collapse navbar-collapse" 
          id="navbarSupportedContent"
        >
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link 
                to='/proyects' 
                className={`nav-link ${currentLocation === '/proyects' ? 'active' : ''}`} 
              >
                Proyectos
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to='/about' 
                className={`nav-link ${currentLocation === '/about' ? 'active' : ''}`}  
              >
                Taller
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to='/contact' 
                className={`nav-link ${currentLocation === '/contact' ? 'active' : ''}`}  
              >
                Contacto
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Menu;